import { render, staticRenderFns } from "./SideNavigation.vue?vue&type=template&id=1e2e51d7"
import script from "./SideNavigation.vue?vue&type=script&lang=js"
export * from "./SideNavigation.vue?vue&type=script&lang=js"
import style0 from "./SideNavigation.vue?vue&type=style&index=0&id=1e2e51d7&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports